import AgmScroll from './src/index'

AgmScroll.install = function(Vue) {
  Vue.component(AgmScroll.name, AgmScroll)
}

export default AgmScroll
